// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { PaymentErrorHandlers } from '../handlers/payment-error.handlers';
import { PaymentErrorTrackingHandlers } from '../handlers/payment-error.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';

const usePaymentErrorHook = (): void => {
  const { formatMessage } = useIntl();

  const { setMainButtonConfiguration } = useLayoutContextConsumerHook();

  const { handleTrackPaymentErrorTryAgain } = useAppTrackingHook(PaymentErrorTrackingHandlers);

  const { handleSetupPaymentErrorButtonConfiguration } = PaymentErrorHandlers({
    formatMessage,
    handleTrackPaymentErrorTryAgain,
    setMainButtonConfiguration,
  });

  useEffect(() => {
    handleSetupPaymentErrorButtonConfiguration();
  }, []);
};

export { usePaymentErrorHook };
